// extracted by mini-css-extract-plugin
export default {"scoreBoard":"ScoresBoard_scoreBoard__B3RSh","load":"ScoresBoard_load__AcBd7","table":"ScoresBoard_table__dv0dj","scrollingBox":"ScoresBoard_scrollingBox__tTOs+"};